export const COMMON_COMPONENT_PROPS = {
  stylable: true,
  droppable: false,
  defaultAttributes: {},
  traits: [{ type: 'text', name: 'color', label: 'color' }],
};
